var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.loginCallInProgress)?_c('app-splash-screen'):_vm._e(),(!_vm.loginCallInProgress && !_vm.isUserLoggedIn)?_c('app-login'):_vm._e(),(!_vm.loginCallInProgress && _vm.isUserLoggedIn)?_c('app-main'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }